import React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import useModal from 'src/hooks/useModal';
import EntityInspectorDialog from 'src/components/EntityInspector/EntityInspectorDialog/EntityInspectorDialog';
import { stopEventBubble } from 'src/helpers/FPUtils';
import { isCentral } from 'src/components/EntityInspector/tools';
import classNames from 'classnames';
const useStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
        overflow: 'visible'
    },
    inspectBtn: {
        fontSize: 14,
        position: 'absolute',
        zIndex: 9999,
        padding: 0,
        left: 0,
        top: 0,
        backgroundColor: 'black !important'
    },
    defaultColor: {
        color: '#ffe000'
    },
    centralColor: {
        color: '#ff0000'
    }
}));
function InspectorContent({ children, showInspector, entity, endpoint }) {
    const classes = useStyles();
    const { isOpen, closeModal, openModal } = useModal();
    const handleClick = (e) => {
        stopEventBubble(e);
        openModal();
    };
    if (!showInspector && !isOpen)
        return children;
    return (React.createElement("div", { className: classes.wrapper },
        children,
        React.createElement(IconButton, { className: classNames(classes.inspectBtn, classes[isCentral(endpoint) ? 'centralColor' : 'defaultColor']), onClick: handleClick },
            React.createElement(InfoIcon, { color: "inherit", fontSize: "inherit" })),
        isOpen && (React.createElement(EntityInspectorDialog, { entity: entity, onClose: closeModal, endpoint: endpoint }))));
}
export default InspectorContent;
